<template>
  <div class="element-combobox" ref="element-combobox" :class="{disabled: disabled}" :style="customStyle" >
    <span v-show="textDisplay != null" class="text-display">
      {{ textDisplay }}
    </span>
    <div class="w-100 inline color-wrapper">
      <div class="border-panel">
        <div v-if="borderValue == 'none' && !includeText" class="border-display-none">Không viền</div>
        <div v-else-if="!includeText" class="border-display" :style="{'border-top': '3px '+ borderValue}"></div>
         <div v-else class="flex-row">
            <div class="flex label-width-text" v-html="modelValue.text"></div> 
            <div class="border-item-with-text flex" :style="{'border-top': modelValue.value + 'pt '+borderPage}"></div>
          </div>
      </div>
    </div>

    <div class="w-40">
      <div
        @click="triggerClick"
        class="icon-combo-element--dropdown"
        :class="{
          disabled: disabled,
          'point-event-none': readOnly,
          expand: expanded,
        }"
      ></div>
    </div>
  </div>
  <div class="drop-down-element" ref="dropdown" :style="dropdownStyles" v-show="expanded">
    <div class="wrapper-flex">
      <div class="color-default-list">
        <div class="border-box" v-for="(item, key) in defaultElementList" :key="key" @click="clickColorItem(item)" :class="{selected: item.value == borderStyle}">
          <div class="border-item-none" v-if="item.value == 'none'" :style="{'border-top': item.value}">Không viền</div>
          <div class="border-item"  v-else-if="!includeText" :style="{'border-top': '3px ' + item.value}"></div>
          <div v-else class="flex-row">
            <div class="flex label-width-text" v-html="item.text"></div> <div class="border-item-with-text flex" :style="{'border-top': item.value + 'pt ' + borderPage}"></div>
          </div>
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {ref, toRef} from '@vue/reactivity';
import commonFn from '@/commons/commonFunction.js';
import {defineComponent, getCurrentInstance, onMounted, computed, nextTick, watch, onBeforeUnmount} from 'vue';

export default defineComponent({
  name: 'MsElementCombobox',
  extends: msBaseComponent,
  props: {
    borderStyle: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    customStyle: {
      type: String,
      default: '',
    },
    includeText: {
      type: Boolean,
      default: null
    },
    borderPage: {
      type: String,
      default: null,
    },
    modelValue: {
       type: Object,
       default: {value: 'solid', borderWidthDefault: 1},
    },
    defaultElementList:{
      type: Array,
      default: () => [
        {value: 'none'}, 
        {value: 'solid', borderWidthDefault: 1}, 
        {value: 'dotted', borderWidthDefault: 1},
        {value: 'dashed', borderWidthDefault: 1},
        {value: 'inset', borderWidthDefault: 3},
        {value: 'outset', borderWidthDefault: 3},
        {value: 'ridge', borderWidthDefault: 3},
        {value: 'groove', borderWidthDefault: 3},
        {value: 'double', borderWidthDefault: 3}
        ],
    }
  },
  emits: ['update:borderStyle'],
  components: {
  },
  setup(props, {emit}) {
    const expanded = ref(false);
    const borderValue = ref(props.borderStyle);
    const heightDropUp = ref(100); // Fix vì thành phần bên trong của color picker sẽ không đổi nên không cần custom độ cao, độ dài
    const widthDropUp = ref(252);
    const isSetting = ref(false);
    const textDisplay = ref(props.text);

    // giá trị border mặc định
    // const defaultElementList = ref();

    let containerWidth = 0;
    let dropdownContainer = ref();
    //  Thuộc tính dành cho drop up color pick
    let dropdownLeftx = ref();
    let dropdownWidth = ref();
    let dropdownTopx = ref();
    let dropdownMinWidthx = ref();
    let dropdownMaxWidthx = ref();
    // Thuộc tính dành cho drop up color pick của thư viện vue3-colorpicker
    let dropdownLeftxSetting = ref();
    let dropdownWidthSetting = ref();
    let dropdownTopxSetting = ref();
    let dropdownMinWidthxSetting = ref();
    let dropdownMaxWidthxSetting = ref();

    const {proxy} = getCurrentInstance();

    onMounted(() => {
      let me = proxy;
      document.addEventListener('click', me.clickOut);
    });

    onBeforeUnmount(() => {
      let me = proxy;
      document.removeEventListener('click', me.clickOut);
    });

    /**
     * Sự kiện clikc ra ngoài để ẩn color picker
     */
    function clickOut(e) {
      const me = proxy;
      if (
        me.$refs['element-combobox'] &&
        !commonFn.hasParent(e.target, me.$refs['element-combobox']) &&
        !commonFn.hasClass(e.target, 'element-combobox') &&
        !commonFn.hasParent(e.target, me.$refs['dropdown']) &&
        !commonFn.hasClass(e.target, 'drop-down-element') &&
        !commonFn.hasParent(e.target, me.$refs['setting-panel'])
      ) {
        if (
          !(
            commonFn.hasClass(e.target, 'advance') ||
            commonFn.hasClass(e.target, 'back') ||
            commonFn.hasClass(e.target.childNodes[0], 'back')
          )
        ) {
          me.$nextTick(() => {
            me.expanded = false;
            me.isSetting = false;
          });
        }
      } else {
        if (commonFn.hasParent(e.target, me.$refs['dropdown']) && !commonFn.hasClass(e.target, 'color-setting')) {
          me.isSetting = false;
        }
      }
    }

    /**
     * Tính toán lại vị trí của colorpicker của thư viện vue3-colorpicker
     * tbngoc 21.06.20222
     */
    function calulateSettingPosistion() {
      let me = proxy,
        comboEl = me.$el;
      if (comboEl) {
        comboEl = me.$refs['setting'];
      }
      let gapDropUp = 8;
      let heightSetting = 330; // Fix vì lấy độ cao của popup vue3-colorpicker
      let widthSetting = 276;
      if (comboEl) {
        let comboElRect = comboEl.getBoundingClientRect(),
          comboMenuEl = me.$el;

        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        me.dropdownLeftxSetting = comboElRect.left;

        me.dropdownMaxWidthxSetting = widthSetting;
        //Nếu chạm trên thì chuyển xuống dưới
        if (comboElRect.top - heightSetting - gapDropUp < 0) {
          me.dropdownTopxSetting = comboElRect.top + gapDropUp;
        } else {
          me.dropdownTopxSetting = comboElRect.top - heightSetting - gapDropUp;
        }
        // Nếu chạm phải thì align sang trái
        if (comboElRect.left + me.dropdownMaxWidthxSetting > windowWidth) {
          me.dropdownLeftxSetting = comboElRect.right - me.dropdownMaxWidthxSetting;
        }
      }
    }

    // Watch giá trị của hiển thị color picker của thư viện
    watch(
      () => isSetting.value,
      (value, oldValue) => {
        if (value == true) {
          calulateSettingPosistion();
        }
      },
      {immediate: true},
    );

    // Watch giá trị của hiển thị color picker của thư viện
    watch(
      () => borderValue.value,
      (value, oldValue) => {
        let me = proxy;
        me.$emit('update:borderStyle', value);
      },
      {immediate: true},
    );

    watch(
      () => props.borderStyle,
      (value, oldValue) => {
        borderValue.value = value;
      },
      {immediate: true},
    );

    onMounted(() => {
      nextTick(() => {
        if (dropdownContainer.value) {
          containerWidth = dropdownContainer.value.clientWidth;
        }
      });
    });
    /**
     * hiển thị dropdown
     */
    function expand() {
      const me = this;

      me.$emit('beforeExpand');

      //đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = true;
      });
    }
    /**
     * click vào icon dropdown
     * tbngoc 20.06.2022
     */
    function triggerClick(e) {
      const me = this,
        expanded = me.expanded;
      //disable thì không làm gì
      if (me.disabled) {
        return;
      }

      if (!expanded) {
        // if (me.pagination) {
        //me.doQueryInternal(null, true);
        me.changeDropdownPosition();
      } else {
        me.isSetting = false;
      }

      //đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = !expanded;
      });
    }
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * tbngoc 20.06.2022
     */
    function changeDropdownPosition() {
      let me = proxy,
        comboEl = me.$el;
      if (comboEl) {
        comboEl = me.$refs['element-combobox'];
      }
      let gapDropUp = 32;

      if (comboEl) {
        let comboElRect = comboEl.getBoundingClientRect(),
          comboMenuEl = me.$el;

        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        me.dropdownLeftx = comboElRect.left;
        widthDropUp.value = comboElRect.width;
        me.dropdownMaxWidthx = widthDropUp.value;
        me.dropdownTopx = comboElRect.top + gapDropUp;
        // Nếu chạm phải thì align sang trái
        if (comboElRect.left + me.dropdownMaxWidthx > windowWidth) {
          me.dropdownLeftx = comboElRect.right - me.dropdownMaxWidthx;
        }
      }
    }

    /**
     * Sự kiện chọn màu default
     * tbngoc 20.06.2022
     */
    function clickColorItem(item) {
      let me = proxy;
      me.borderValue = item.value;
      props.modelValue = item;
      me.expanded = false;
      
    }

    /**
     * Hàm set vị trí cho dropdown khi mở color picker của thư viện
     * tbngoc 21.06.2022
     */
    function changeDropdownSettingPosition() {}

    const headerWidth = computed(() => {
      let width = 0;
      if (containerWidth) {
        width = containerWidth;
      }
      return width;
    });

    /**
     * Computed thiết lập style cho color picker
     * tbngoc 20.06.2022
     */
    const dropdownStyles = computed(() => {
      let me = proxy;
      let width = headerWidth,
        docWidth = document.body.clientWidth,
        left = me.dropdownLeftx;
      if (left + width + me.dropdownWidth > docWidth) {
        left = left - (width + left + me.dropdownWidth - docWidth);
      }

      let res = {
        top: me.dropdownTopx + 'px',
        // left: left + "px",
        minWidth: me.dropdownMinWidthx + 'px',
        width: widthDropUp.value + 'px',
      };

      if (left + width >= docWidth) {
        res.right = '10px';
      } else {
        res.left = left + 'px';
      }
      return res;
    });

    /**
     * Computed thiết lập style cho color picker của thư viện vue3-colorpicker
     * tbngoc 21.06.2022
     */
    const dropdownSettingStyles = computed(() => {
      let me = proxy;
      let width = headerWidth,
        docWidth = document.body.clientWidth,
        left = me.dropdownLeftxSetting;
      if (left + width + me.dropdownWidth > docWidth) {
        left = left - (width + left + me.dropdownWidth - docWidth);
      }

      let res = {
        top: me.dropdownTopxSetting + 'px',
        // left: left + "px",
        minWidth: me.dropdownMinWidthxSetting + 'px',
        position: 'absolute',
      };

      if (left + width >= docWidth) {
        res.right = '10px';
      } else {
        res.left = left + 'px';
      }
      return res;
    });

    return {
      triggerClick,
      expanded,
      expand,
      borderValue,
      changeDropdownPosition,
      dropdownStyles,
      dropdownLeftx,
      dropdownWidth,
      dropdownTopx,
      dropdownMinWidthx,
      dropdownMaxWidthx,
      clickColorItem,
      isSetting,
      dropdownSettingStyles,
      dropdownLeftxSetting,
      dropdownWidthSetting,
      dropdownTopxSetting,
      dropdownMinWidthxSetting,
      dropdownMaxWidthxSetting,
      clickOut,
      textDisplay
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsElementCombobox.scss';
</style>
